import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import {AngularMaterialModule} from '../angular-material/angular-material.module';
import {TranslateModule} from '@ngx-translate/core';
import { NotFoundComponent } from './components/not-found/not-found.component';
import {ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import { AppToolbarComponent } from './components/app-toolbar/app-toolbar.component';
import {AppRoutingModule} from '../app-routing.module';
import { LateralMenuComponent } from './components/lateral-menu/lateral-menu.component';
import { BreadcrumbToolbarComponent } from './components/breadcrumb-toolbar/breadcrumb-toolbar.component';
import {LoaderComponent} from './components/loader/loader.component';
import {SharedModule} from '../shared/shared.module';
import { DownloadDataDialogComponent } from './components/download-data-dialog/download-data-dialog.component';
import { ChangePasswordDialogComponent } from './components/change-password-dialog/change-password-dialog.component';
import { NotAllowedComponent } from './components/not-allowed/not-allowed.component';


@NgModule({
  declarations: [
    LoginComponent,
    NotFoundComponent,
    AppToolbarComponent,
    LateralMenuComponent,
    BreadcrumbToolbarComponent,
    LoaderComponent,
    DownloadDataDialogComponent,
    ChangePasswordDialogComponent,
    NotAllowedComponent
  ],
    exports: [
        AppToolbarComponent,
        LateralMenuComponent,
        BreadcrumbToolbarComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        TranslateModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        AppRoutingModule,
        SharedModule
    ]
})
export class CoreModule { }
